import type { Language, OrderHistoryDto } from '@posilka/shared';
import { useTranslation } from 'react-i18next';
import { formatDateTime } from '@posilka/client/lib/time';

export function Timeline({ history }: { history: OrderHistoryDto[] }) {
  const { t, i18n } = useTranslation();
  return (
    <ol className="px-5 py-4">
      {history.map((h, i) => (
        <li key={i} className="relative flex gap-3 pb-3 last:pb-0">
          <span
            className={`relative z-10 mt-1 h-3.5 w-3.5 shrink-0 rounded-full border-2 ${
              i === history.length - 1
                ? 'border-lime bg-lime shadow-[0_0_0_4px_var(--glow)]'
                : 'border-line bg-surface-2'
            }`}
          />
          {i < history.length - 1 && (
            <span className="absolute top-4 left-[6.5px] h-full w-px bg-line" />
          )}
          <div className="flex flex-1 justify-between gap-2 text-sm">
            <span>{t(`status.${h.toStatus}`)}</span>
            <span className="text-hint">
              {formatDateTime(h.createdAt, i18n.language as Language)}
            </span>
          </div>
        </li>
      ))}
    </ol>
  );
}
